<template>
    <label class="switch">
        <input type="checkbox" @click="toggleCheckbox" :checked="checked" />
        <div class="slider round" :class="checked ? 'on' : 'off'"></div>
    </label>
</template>

<script>
export default {
    name: 'ToggleSwitch',
    props: {
        checked: Boolean
    },

    setup(props, { emit }) {
        const toggleCheckbox = () => {
            emit('setCheckValue', !props.checked)
        }

        return { toggleCheckbox }
    }
}
</script>

<style scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 18px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider.on:before {
    left: -8px;
}

.slider.off:before {
    left: 3px;
}

input:checked + .slider {
    background-color: #132c8c;
}

input:focus + .slider {
    box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
